import { Component } from "@angular/core";
import { AutoUnsubscribe } from "../../shared/decorators/auto-unsubscribe.decorator";
import { FaxQueueComponent } from "../base/fax-queue.component";
import { FaxQueue } from "projects/um/src/assets/constants";

@Component({
  selector: 'app-my-queue-faxes',
  templateUrl: './my-queue-faxes.component.html',
  styleUrls: ['./my-queue-faxes.component.scss'],
  standalone: false
})

@AutoUnsubscribe
export class MyQueueFaxesComponent extends FaxQueueComponent {
    override faxView: FaxQueue = FaxQueue.MY_FAXES;
}